import { render, staticRenderFns } from "./NavbarContent.vue?vue&type=template&id=2d056da0&scoped=true&"
import script from "./NavbarContent.vue?vue&type=script&lang=js&"
export * from "./NavbarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d056da0",
  null
  
)

export default component.exports